import ImageContainer from './Image'
import { imgLazyLoad } from 'components/common/hoc/withLazyLoader'

export default imgLazyLoad(ImageContainer)
